var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "color-sample-sidebar" }, [
    _c("span", { staticClass: "color-sample-checkout-title" }, [
      _vm._v(_vm._s(_vm.trans("sample_order_checkout"))),
    ]),
    _c("div", { attrs: { id: "color-sample-cost" } }, [
      _c("div", { staticClass: "color-sample-cost-row" }, [
        _c("div", { staticClass: "cell" }, [
          _vm._v(_vm._s(_vm.trans("sample_order_subtotal"))),
        ]),
        _c("div", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.getSubtotal))]),
      ]),
      _c("div", { staticClass: "color-sample-cost-row" }, [
        _c("div", { staticClass: "cell" }, [
          _vm._v(_vm._s(_vm.trans("sample_order_optional_cost"))),
        ]),
        _c("div", { staticClass: "cell" }, [
          _vm._v(_vm._s(_vm.getOptionalCost)),
        ]),
      ]),
      _c("div", { staticClass: "color-sample-cost-row" }, [
        _c("div", { staticClass: "cell" }, [
          _vm._v(
            _vm._s(_vm.trans("sample_order_vat")) +
              " (" +
              _vm._s(_vm.getVatPercent) +
              ")"
          ),
        ]),
        _c("div", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.getVat))]),
      ]),
      _c("div", { staticClass: "color-sample-cost-row" }, [
        _c("div", { staticClass: "cell" }, [
          _vm._v(_vm._s(_vm.trans("sample_order_total"))),
        ]),
        _c("div", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.getTotal))]),
      ]),
      _vm.currentStep < 3
        ? _c(
            "div",
            {
              staticClass:
                "color-sample-cost-row color-order-checkout-container",
            },
            [
              false
                ? _c(
                    "div",
                    {
                      class: _vm.getCheckoutClasses,
                      attrs: { id: "color-order-checkout" },
                      on: { click: _vm.forward },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.trans("sample_order_proceed_to_checkout")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _c(
                    "button",
                    {
                      class: "button type-2 w-100 " + _vm.getCheckoutClasses,
                      attrs: { type: "button", id: "color-order-checkout-v2" },
                      on: { click: _vm.forward },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.trans("sample_order_proceed_to_checkout")
                          ) +
                          " "
                      ),
                    ]
                  ),
            ]
          )
        : _vm._e(),
      _vm.currentStep === 3
        ? _c("div", [
            _c("span", { staticClass: "color-sample-checkout-title" }, [
              _vm._v(_vm._s(_vm.trans("sample_order_payment_method"))),
            ]),
            _c(
              "div",
              { staticClass: "color-sample-payment-methods" },
              _vm._l(_vm.paymentMethods, function (method, key) {
                return _c("div", { key: key }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-sample-payment-method-icon d-inline-block",
                    },
                    [
                      _c("i", {
                        class: "fa fa-" + method.icon,
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-sample-payment-method-name d-inline-block ml-3",
                    },
                    [_vm._v(" " + _vm._s(method.name) + " ")]
                  ),
                  method.extraIcons && method.extraIcons.length > 0
                    ? _c(
                        "div",
                        { staticClass: "clearfix payment-method-extra-icons" },
                        _vm._l(method.extraIcons, function (extraIcon, index) {
                          return _c("i", {
                            key: "extra-icon-" + index,
                            class: "fa fa-lg mr-2 fa-" + extraIcon,
                            attrs: { "aria-hidden": "true" },
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              }),
              0
            ),
            false
              ? _c(
                  "div",
                  {
                    class: _vm.getCheckoutClasses,
                    attrs: { id: "color-order-checkout" },
                    on: { click: _vm.pay },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.trans("sample_order_continue_to_payment")) +
                        " "
                    ),
                  ]
                )
              : _c(
                  "button",
                  {
                    class: "button type-2 w-100 " + _vm.getCheckoutClasses,
                    attrs: { id: "color-order-checkout-v2" },
                    on: { click: _vm.pay },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.trans("sample_order_continue_to_payment")) +
                        " "
                    ),
                  ]
                ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }